import React from 'react';
import { Card, Typography, Tag, Badge } from 'antd';
import { 
  UserOutlined, 
  TeamOutlined, 
  BankOutlined, 
  CheckCircleOutlined,
  ClockCircleOutlined 
} from '@ant-design/icons';
import { CategoryTileProps } from '../types';
import {CustomerType} from "@/shared/api/model";

const { Title, Paragraph } = Typography;

const CategoryTile: React.FC<CategoryTileProps> = ({
  category,
  onClick,
  isSelected = false,
  disabled = false,
}) => {
  const getCustomerTypeIcon = (customerType: CustomerType|null|undefined) => {
    switch (customerType) {
      case 'INDIVIDUAL':
        return <UserOutlined />;
      case 'GROUP':
        return <TeamOutlined />;
      case 'BUSINESS':
        return <BankOutlined />;
      default:
        return <UserOutlined />;
    }
  };

  const getCustomerTypeColor = (customerType: CustomerType|null|undefined) => {
    switch (customerType) {
      case 'INDIVIDUAL':
        return 'blue';
      case 'GROUP':
        return 'green';
      case 'BUSINESS':
        return 'purple';
      default:
        return 'default';
    }
  };

  const handleClick = () => {
    if (!disabled) {
      onClick(category);
    }
  };

  return (
    <Badge.Ribbon
      text={category.status  === 'ACTIVE' ? 'Active' : 'Inactive'}
      color={category.status === 'ACTIVE' ? 'green' : 'red'}
    >
      <Card
        className={`category-tile ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
        hoverable={!disabled}
        onClick={handleClick}
        cover={
          <div className="category-tile-header">
            <div className="category-icon">
              {getCustomerTypeIcon(category.customerType)}
            </div>
            <Tag 
              color={getCustomerTypeColor(category.customerType)}
              className="customer-type-tag"
            >
              {category.customerType}
            </Tag>
          </div>
        }
        actions={[
          category.status === 'ACTIVE' ? (
            <CheckCircleOutlined key="active" style={{ color: '#52c41a' }} />
          ) : (
            <ClockCircleOutlined key="inactive" style={{ color: '#faad14' }} />
          ),
        ]}
      >
        <Card.Meta
          title={
            <Title level={4} className="category-title">
              {category.name}
            </Title>
          }
          description={
            <div className="category-description">
              <Paragraph ellipsis={{ rows: 2, expandable: false }}>
                {category.description}
              </Paragraph>
              
              {category.isSubPart && (
                <Tag color="orange">
                  Sub-part: {category.subPartType}
                </Tag>
              )}
              
              <div className="category-stats">
                <span className="stat-item">
                  Products: {category.products?.length || 0}
                </span>
                <span className="stat-item">
                  Fields: {category.fields?.length || 0}
                </span>
              </div>
            </div>
          }
        />
      </Card>
    </Badge.Ribbon>
  );
};

export default CategoryTile;
